"use strict";var inherit = require("raptor-util/inherit");
var VNode = require("./VNode");

function VComponent(component, key, ownerComponent, preserve) {
  this.bY_(null /* childCount */, ownerComponent);
  this.ca_ = key;
  this.s_ = component;
  this.af_ = preserve;
}

VComponent.prototype = {
  c__: 2
};

inherit(VComponent, VNode);

module.exports = VComponent;